export function getObservationSchema() {
  return [
    {
      name: "id",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: [],
      helperText: "",
      nullable: false,
      readOnly: true,
      error: false,
    },
    {
      name: "Description",
      default: "",
      type: "string",
      maxLength: 500,
      selectables: [],
      similair: [
        "descript",
        "desc",
        "observation",
        "notes",
        "comment",
        "comments",
        "obs",
        "observa",
      ],
      nullable: false,
      readOnly: false,
      helperText: "Observation Description",
      error: false,
    },
    {
      name: "Date",
      default: "",
      type: "date",
      maxLength: 80,
      selectables: [],
      similair: ["obs date", "observation date", "date observed"],
      helperText: "",
      nullable: false,
      readOnly: false,
      error: false,
    },
    {
      name: "Type",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [
        "Field Visit",
        "Client Report",
        "Staff Report",
        "Email Documentation",
        "Picture Documentation",
      ],
      similair: ["source", "mode"],
      helperText: "What Type of observation was performed?",
      nullable: false,
      readOnly: false,
      error: false,
    },
    {
      name: "Present",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: [
        "group",
        "group Name",
        "category",
        "category Name",
        "categories",
      ],
      helperText: "Who was present",
      nullable: true,
      readOnly: false,
      error: false,
    },
    {
      name: "Weather",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: ["wind", "temp", "forcast", "temps"],
      helperText: "What was the weather like today",
      nullable: true,
      readOnly: false,
      error: false,
    },
    {
      name: "Location",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: ["room", "place", "location", "area"],
      helperText: "Where was the work observed?",
      nullable: true,
      readOnly: false,
      error: false,
    },
  ];
}
